// extracted by mini-css-extract-plugin
module.exports = {"container":"FileUpload_container__3K2-F","actions":"FileUpload_actions__aASsH","maxSize":"FileUpload_maxSize__1Dog7","button":"FileUpload_button__3ysj7"};